"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _I18n = _interopRequireDefault(require("I18n"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _DealsStore = _interopRequireDefault(require("crm_data/deals/DealsStore"));

var _AssociationsStore = _interopRequireDefault(require("crm_data/associations/AssociationsStore"));

var _ElasticSearchStore = _interopRequireDefault(require("crm_data/elasticSearch/ElasticSearchStore"));

var _ContactsStore = _interopRequireDefault(require("crm_data/contacts/ContactsStore"));

var _CompaniesStore = _interopRequireDefault(require("crm_data/companies/CompaniesStore"));

var _TicketsStore = _interopRequireDefault(require("crm_data/tickets/TicketsStore"));

var _getContactsAssociationsOptions = _interopRequireDefault(require("./getContactsAssociationsOptions"));

var _getDealsAssociationsOptions = _interopRequireDefault(require("./getDealsAssociationsOptions"));

var _getCompaniesAssociationsOptions = _interopRequireDefault(require("./getCompaniesAssociationsOptions"));

var _getTicketsAssociationsOptions = _interopRequireDefault(require("./getTicketsAssociationsOptions"));

var _ElasticSearchConstants = require("customer-data-objects/search/ElasticSearchConstants");

var _makeElasticSearchUISelectDependency = _interopRequireDefault(require("crm_data/elasticSearch/dependencies/makeElasticSearchUISelectDependency"));

var _ElasticSearchValidation = require("crm_data/elasticSearch/ElasticSearchValidation");

var shouldSearchAllObjects = function shouldSearchAllObjects(_ref) {
  var searchText = _ref.searchText;
  return !!searchText.length && (0, _ElasticSearchValidation.isOfMinSearchLength)(searchText);
};

var formatOptions = function formatOptions(options) {
  return options && options.map(function (_ref2) {
    var text = _ref2.text,
        value = _ref2.value;
    return {
      text: text,
      value: value
    };
  });
};

var allContactOptions = (0, _makeElasticSearchUISelectDependency.default)(_ContactsStore.default, _ObjectTypes.CONTACT, {
  filterOptions: false,
  minimumSearchLength: _ElasticSearchConstants.MIN_SEARCH_LENGTH
}).deref;
var allCompanyOptions = (0, _makeElasticSearchUISelectDependency.default)(_CompaniesStore.default, _ObjectTypes.COMPANY, {
  filterOptions: false,
  minimumSearchLength: _ElasticSearchConstants.MIN_SEARCH_LENGTH
}).deref;
var allDealOptions = (0, _makeElasticSearchUISelectDependency.default)(_DealsStore.default, _ObjectTypes.DEAL, {
  filterOptions: false,
  minimumSearchLength: _ElasticSearchConstants.MIN_SEARCH_LENGTH
}).deref;
var allTicketOptions = (0, _makeElasticSearchUISelectDependency.default)(_TicketsStore.default, _ObjectTypes.TICKET, {
  filterOptions: false,
  minimumSearchLength: _ElasticSearchConstants.MIN_SEARCH_LENGTH
}).deref;
var _default = {
  propTypes: {
    objectType: _ObjectTypesType.default.isRequired,
    subjectId: _react.PropTypes.string,
    subject: _react.PropTypes.object,
    values: _react.PropTypes.object
  },
  stores: [_DealsStore.default, _ContactsStore.default, _CompaniesStore.default, _TicketsStore.default, _ElasticSearchStore.default, _AssociationsStore.default],
  deref: function deref(_ref3) {
    var objectType = _ref3.objectType,
        searchText = _ref3.searchText,
        debouncedSearchTextForElasticSearch = _ref3.debouncedSearchTextForElasticSearch,
        subjectId = _ref3.subjectId,
        subject = _ref3.subject,
        objectTypesToAssociate = _ref3.objectTypesToAssociate,
        values = _ref3.values;
    return [{
      objectTypeLabel: _ObjectTypes.CONTACT,
      fetcher: shouldSearchAllObjects({
        searchText: searchText
      }) ? allContactOptions : _getContactsAssociationsOptions.default
    }, {
      objectTypeLabel: _ObjectTypes.COMPANY,
      fetcher: shouldSearchAllObjects({
        searchText: searchText
      }) ? allCompanyOptions : _getCompaniesAssociationsOptions.default
    }, {
      objectTypeLabel: _ObjectTypes.DEAL,
      fetcher: shouldSearchAllObjects({
        searchText: searchText
      }) ? allDealOptions : _getDealsAssociationsOptions.default
    }, {
      objectTypeLabel: _ObjectTypes.TICKET,
      fetcher: shouldSearchAllObjects({
        searchText: searchText
      }) ? allTicketOptions : _getTicketsAssociationsOptions.default
    }].filter(function (_ref4) {
      var objectTypeLabel = _ref4.objectTypeLabel;
      return objectTypesToAssociate.includes(objectTypeLabel);
    }).map(function (_ref5) {
      var objectTypeLabel = _ref5.objectTypeLabel,
          fetcher = _ref5.fetcher;
      return {
        text: _I18n.default.text("customerDataCommunicator.MultipleAssociationsSelect." + objectTypeLabel),
        options: formatOptions(fetcher({
          objectType: objectType,
          subjectId: subjectId,
          subject: subject,
          state: {
            searchText: searchText,
            debouncedSearchTextForElasticSearch: debouncedSearchTextForElasticSearch
          },
          values: values
        }))
      };
    });
  }
};
exports.default = _default;
module.exports = exports.default;